import { EMAIL_REGEX } from '../constants/form';

export const isEmailValid = (email: string): boolean =>
  Boolean(EMAIL_REGEX.test(email));

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const lowercaseFirstLetter = (str: string) => {
  return str.charAt(0).toLowerCase() + str.slice(1);
};

export const nl2br = (str) => {
  if (typeof str === 'undefined' || str === null) {
    return '';
  }

  return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2');
};

export const safeJsonParse = (str: string | null) => {
  if (!str) return null;

  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
};

export const toCamelCase = (str: string) => {
  return str.replace(/([-_][a-z])/gi, ($1) =>
    $1.toUpperCase().replace('-', '').replace('_', ''),
  );
};

export const toPascalCase = (str: string) => {
  return toCamelCase(str).replace(
    /(\w)(\w*)/g,
    (_, g1, g2) => g1.toUpperCase() + g2,
  );
};

export const findAndReplace = (
  text: string | undefined | null,
  search: string | undefined | null,
  replace: string | undefined | null,
): string => {
  if (!text) return '';
  if (!search || !replace) return text;

  return text.split(search).join(replace);
};
